import GameCard from '../../../components/GameCard'
import DemoFrame from './DemoFrame'
import { demoGame, demoNoop } from './demoFixtures'

const GAME = demoGame('banker', 'tottenham', 'fulham')

/**
 * One settled fixture carrying the Banker crown, in the state that makes the mechanic legible:
 * a correct outcome worth 3, doubled to 6, with the card's own "3 → 6 pts" footer doing the
 * explaining. The crown is the same badge the real grid draws — there is no separate toggle
 * component in this app, the slot lives on the card.
 */
export default function BankerDemo() {
  return (
    <DemoFrame className="rules-demo--single">
      <GameCard
        demo
        game={GAME}
        prediction={{ gameId: GAME.id, homeScore: 2, awayScore: 0 }}
        actualResult={{ homeScore: 3, awayScore: 1 }}
        onClick={demoNoop}
        isBanker
        isDoubleUpActive={false}
        isCleanSweepActive={false}
        deadlinePassed
      />
    </DemoFrame>
  )
}
